import { LitState, stateVar } from 'lit-element-state';
import { delCookie } from 'chipta-libs/utils/cookies.js';
import ticketshopAPI from 'chipta-libs/api/ticketshop.js';


class UserDataState extends LitState {

  constructor() {
    super();
    this.id = stateVar(null);
    this.email = stateVar(null);
    this.first_name = stateVar(null);
    this.last_name = stateVar(null);
    this.logging_in = stateVar(false);
    this.logged_in = stateVar(false);
  }

  login(email, password, rememberMe=false) {

    userData.logging_in = true;

    return new Promise((success, reject) => {

      ticketshopAPI.login(email, password, rememberMe).then(newUserData => {

        for (let key in newUserData) {
          userData[key] = newUserData[key];
        }

        userData.logged_in = true;
        userData.logging_in = false;

        success();

      }).catch(error => {
        userData.logged_in = false;
        userData.logging_in = false;
        reject(error);
      });

    });

  }

  logout() {

    return new Promise((success, reject) => {

      ticketshopAPI.logout().then(result => {

        userData.logged_in = false;
        userData.email = '';
        userData.first_name = '';
        userData.last_name = '';

        // FIXME: Deleting cookies with this plugin does not seem to work, so
        // they are also deleted in the python API side.
        delCookie('facebook-auto-login');
        delCookie('autoLogin');

        success(result);

      }).catch(error => {
        reject(error);
      });

    });

  }

}


const userData = new UserDataState();

Object.assign(userData, jsVar('userData'));

export { userData };
